import { render, staticRenderFns } from "./AltPreloader.vue?vue&type=template&id=4e4567d6"
import script from "./AltPreloader.vue?vue&type=script&lang=js"
export * from "./AltPreloader.vue?vue&type=script&lang=js"
import style0 from "./AltPreloader.vue?vue&type=style&index=0&id=4e4567d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports